import { render, staticRenderFns } from "./DisplayPropertiesSidebar.vue?vue&type=template&id=18411ce7&scoped=true"
import script from "./DisplayPropertiesSidebar.vue?vue&type=script&lang=js"
export * from "./DisplayPropertiesSidebar.vue?vue&type=script&lang=js"
import style0 from "./DisplayPropertiesSidebar.vue?vue&type=style&index=0&id=18411ce7&prod&lang=scss"
import style1 from "./DisplayPropertiesSidebar.vue?vue&type=style&index=1&id=18411ce7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18411ce7",
  null
  
)

export default component.exports